<div class="app-layout">
    <div class="app-layout__container">
      <div class="row app-layout__row">
        <div class="col-xl-2 col-lg-2 d-none d-lg-block app-layout__sidebar">
          <app-sidebar></app-sidebar>
        </div>
  
        <div class="col-xl-10 col-lg-10 col-md-12 col-sm-12 col-12 app-layout__main">
          <app-header (menuClick)="toggleMobileSidebar()"></app-header>
  
          <main class="app-layout__page">
            <router-outlet></router-outlet>
          </main>
        </div>
      </div>
    </div>
  
    <app-sidebar [isMobile]="true" [mobileOpen]="mobileSidebarOpen" (closed)="toggleMobileSidebar()"></app-sidebar>
</div>